import {PaginationDto} from "../../common/dto/PaginationDto";

export class CardSearchCondition extends PaginationDto {
    number: string = '';
    status: string = '';
    classify: string = '';
    terminalId: string = '';
}
